import { LoginRequest } from "../../../@types/Auth";
import { api } from "../../api";

export default async function login(dto: LoginRequest) {
  try {
    const { data, status } = await api.post("/auth/login", {
      email: dto.email,
      password: dto.password,
    });

    if (status === 200) {
      const token = data.data.token;

      localStorage.setItem("auth_token", token);
      localStorage.setItem(
        "auth_token_created_at",
        new Date().getTime().toString()
      );
      return data;
    }

    return null;
  } catch (err: any) {
    const msg = err?.response?.data?.msg;
    console.log(err);

    if (msg === "User inactive") {
      return err.response.data;
    }

    return null;
  }
}
